module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-horizontal"
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "for": "radios-0"
    }
  }, [_vm._v("Hauptadresse")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "radio-inline",
    attrs: {
      "for": "radios-0"
    }
  }, [_c('input', {
    attrs: {
      "name": "radios",
      "id": "radios-0",
      "value": "true",
      "type": "radio"
    },
    domProps: {
      "checked": _vm.model.model.is_main
    },
    on: {
      "click": function($event) {
        _vm.model.model.is_main = true
      }
    }
  }), _vm._v("\n\t\t\t\t\tJa\n\t\t\t\t")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline",
    attrs: {
      "for": "radios-1"
    }
  }, [_c('input', {
    attrs: {
      "name": "radios",
      "id": "radios-1",
      "value": "false",
      "type": "radio"
    },
    domProps: {
      "checked": !_vm.model.model.is_main
    },
    on: {
      "click": function($event) {
        _vm.model.model.is_main = false
      }
    }
  }), _vm._v("\n\t\t\t\t\tNein\n\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label text-right",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "for": "selectbasic"
    }
  }, [_vm._v("Art")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.address_type),
      expression: "model.model.address_type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectbasic",
      "name": "selectbasic"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.model.model.address_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$store.getters.models('address_types')), function(kind) {
    return _c('option', {
      domProps: {
        "value": kind.id
      }
    }, [_vm._v(_vm._s(kind.name))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "for": "textinput"
    }
  }, [_vm._v("Straße")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.street),
      expression: "model.model.street"
    }],
    staticClass: "form-control input-md",
    attrs: {
      "id": "textinput",
      "name": "textinput",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.model.model.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.street = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "for": "textinput"
    }
  }, [_vm._v("Hausnummer")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.number),
      expression: "model.model.number"
    }],
    staticClass: "form-control input-md",
    attrs: {
      "id": "textinput",
      "name": "textinput",
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.model.model.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.number = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "for": "textinput"
    }
  }, [_vm._v("Postleitzahl")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters.models('zips'),
      "option-value": "zip",
      "option-text": "zip",
      "custom-text": _vm.computeZip
    },
    model: {
      value: (_vm.selectedZip),
      callback: function($$v) {
        _vm.selectedZip = $$v
      },
      expression: "selectedZip"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ff63956!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/address-content.vue
// module id = 456
// module chunks = 0